import React from "react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../react-hooks/use-services.hook";

export const GeoLocationBrowserApiTestComponent: React.FC = () => {
    const services = useServices();
    const _onGetGeo = () => {
        const onSuccess = (data: GeolocationPosition) => {
            services.dialog.showSimpleTextModal({
                title: "Success GEO",
                text: JSON.stringify({
                    latitude: data?.coords?.latitude,
                    longitude: data?.coords?.longitude
                }, null, 2)
            })
        }

        const onError = (err: GeolocationPositionError) => {
            services.dialog.showSimpleTextModal({
                title: "Error GEO",
                text: JSON.stringify({
                    code: err?.code,
                    message: err?.message
                }, null, 2)
            })
        }

        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }

    return (
        <Button preset={"primary"} onClick={_onGetGeo}>Get GEO</Button>
    );
}